import React from "react";
import TexCell from "../../../tables/components/atom/TexCell";
import Badge from "../../../tables/components/atom/Badge";

const TableRow = ({ requests }) => {
  const {
    request_id,
    created_at,
    department,
    position_type,
    assigned,
    position,
    status,
  } = requests;
  return (
    <tr className="border-t hover:bg-gray-50">
      <TexCell text={request_id} />
      <TexCell text={created_at} />
      <TexCell text={department} />
      <TexCell text={position_type} />
      <TexCell text={assigned} />
      <TexCell text={position} />
      <TexCell text={status} />
      <td className="p-4">
        <Badge status={status} />
      </td>
    </tr>
  );
};

export default TableRow;
